import React, { useState } from 'react';
import { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { createBlogPost, updateBlogMainImage } from '@/services/blogService';
import { fetchAllUsers } from '@/services/userService';
import { chatWithGPT } from '@/services/openAiService';
import { TextField, Grid, Box, Button, Typography, Alert } from '@mui/material';
import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { getBlogValidationSchema as validationSchema } from '../BlogsForm/Validations/ValidationBlogsSchema';
import Label from '@/components/form/Label/Label';

const BlogsForm = () => {
  //const { mutate } = useCreateSpace();
  const [successMessage, setSuccessMessage] = useState('');
  const [chatLog, setChatLog] = useState([]);
  const [users, setUsers] = useState([]);

  const editorRef = useRef(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetchAllUsers();
        setUsers(response);
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
      }
    };

    fetchUsers();
  }, []);

  const handleSubmit = async (values, { resetForm }) => {
    console.log(JSON.stringify(values));
    try {
      const createdBlog = await createBlogPost(values);

      if (!createdBlog || !createdBlog.post_id) {
        throw new Error('No se recibió un post_id válido al crear el blog');
      }

      const postId = createdBlog.post_id;
      console.log('Post ID obtenido de la respuesta:', postId);

      if (values.post_img && values.post_img.length > 0) {
        await updateBlogMainImage(postId, values.post_img);
      }

      console.log('Blog creado y/o imagen actualizada con éxito');
      setSuccessMessage('Blog creado y/o imagen actualizada con éxito ');
      resetForm();
    } catch (error) {
      console.error('Error al crear el blog:', error);
      setSuccessMessage('Error al crear el blog');
    }
  };

  return (
    <Formik
      initialValues={{
        post_title: '',
        post_detail: '',
        post_keywords: '',
        author_id: '',
        post_date: '',
        type_id: '',
        state_id: 1,
        post_img: [],
        post_url: '',
        post_title_en: '',
        post_detail_en: '',
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, values, errors, touched }) => {
        console.log('Valores del formulario:', values);
        console.log('Errores de validación:', errors);
        console.log('Campos tocados:', touched);

        const handleSendMessageToGpt = async () => {
          const message = '';
          if (!message.trim()) return;
          console.log('Hola');

          try {
            console.log('Enviando mensaje:', message);
            const data = await chatWithGPT(message);
            const reply = data.choices[0].message.content;

            console.log('Respuesta de ChatGPT:', reply);

            setChatLog(prev => [...prev, { user: message, assistant: reply }]);
          } catch (err) {
            console.error('Error al llamar a ChatGPT:', err);
          }
          setFieldValue(
            'post_detail',
            values.post_title +
              ' este blog ha sido creado para brindarte contenido relevante, informativo y actualizado sobre los temas que más te interesan. Aquí encontrarás artículos cuidadosamente redactados, con ideas frescas y análisis de vanguardia que te ayudarán a mantenerte al día y ampliar tus conocimientos.',
          );
        };

        const handleSendMessageToGptEn = async () => {
          const message = '';
          if (!message.trim()) return;
          console.log('Hi');

          try {
            console.log('Sending message:', message);
            const data = await chatWithGPT(message);
            const reply = data.choices[0].message.content;

            console.log('Answer of ChatGPT:', reply);

            setChatLog(prev => [...prev, { user: message, assistant: reply }]);
          } catch (err) {
            console.error('Error to call ChatGPT:', err);
          }
          setFieldValue(
            'post_detail_en',
            values.post_title_en +
              ' This blog has been created to provide you with relevant, informative, and up-to-date content on the topics that interest you most. Here, you’ll find carefully written articles, with fresh ideas and cutting-edge analysis to help you stay informed and expand your knowledge.',
          );
        };

        return (
          <Form>
            <Typography variant="h4" component="h1" align="center" gutterBottom>
              Crear Blogs
            </Typography>

            <Box sx={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field name="post_title">
                    {({ field }) => (
                      <TextField
                        label="Post Title"
                        fullWidth
                        {...field}
                        error={Boolean(touched.post_title && errors.post_title)}
                        helperText={touched.post_title && errors.post_title}
                      />
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_title_en">
                    {({ field }) => (
                      <TextField
                        label="Post Title (English)"
                        fullWidth
                        {...field}
                        error={Boolean(
                          touched.post_title_en && errors.post_title_en,
                        )}
                        helperText={
                          touched.post_title_en && errors.post_title_en
                        }
                      />
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_detail">
                    {() => (
                      <div>
                        <Label className={'margb10'}>
                          Post Details{' '}
                          <Button
                            variant="contained"
                            component="label"
                            color="secondary"
                            sx={{ marginLeft: '10px' }}
                            onClick={handleSendMessageToGpt}
                          >
                            Mejorar con IA
                          </Button>
                        </Label>

                        <Editor
                          apiKey="2qddd2ef9jx93qzld2ixgyp8lj3esyhzkninni15l4495lnb"
                          onInit={(evt, editor) => (editorRef.current = editor)}
                          value={values.post_detail}
                          init={{
                            height: 300,
                            directionality: 'ltr',
                            menubar: true,
                            language: 'en',
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                          }}
                          onEditorChange={content => {
                            setFieldValue('post_detail', content);
                          }}
                        />
                        {touched.post_detail && errors.post_detail && (
                          <div style={{ color: 'red', marginTop: '0.5rem' }}>
                            {errors.post_detail}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_detail_en">
                    {() => (
                      <div>
                        <Label className={'margb10'}>
                          Post Details (English){' '}
                          <Button
                            variant="contained"
                            component="label"
                            color="secondary"
                            sx={{ marginLeft: '10px' }}
                            onClick={handleSendMessageToGpt}
                          >
                            Improve with AI
                          </Button>
                        </Label>

                        <Editor
                          apiKey="2qddd2ef9jx93qzld2ixgyp8lj3esyhzkninni15l4495lnb"
                          onInit={(evt, editor) => (editorRef.current = editor)}
                          value={values.post_detail_en}
                          init={{
                            height: 300,
                            directionality: 'ltr',
                            menubar: true,
                            language: 'en',
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help',
                          }}
                          onEditorChange={content => {
                            setFieldValue('post_detail_en', content);
                          }}
                        />
                        {touched.post_detail_en && errors.post_detail_en && (
                          <div style={{ color: 'red', marginTop: '0.5rem' }}>
                            {errors.post_detail_en}
                          </div>
                        )}
                      </div>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_keywords">
                    {({ field }) => (
                      <TextField
                        label="Post Keywords"
                        fullWidth
                        {...field}
                        error={Boolean(
                          touched.post_keywords && errors.post_keywords,
                        )}
                        helperText={
                          touched.post_keywords && errors.post_keywords
                        }
                      />
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="author_id">
                    {({ field, form }) => (
                      <TextField
                        select
                        label="Autor"
                        fullWidth
                        {...field}
                        SelectProps={{ native: true }}
                        error={Boolean(
                          form.touched.author_id && form.errors.author_id,
                        )}
                        helperText={
                          form.touched.author_id && form.errors.author_id
                        }
                      >
                        <option value=""> </option>
                        {users.map(user => (
                          <option key={user.user_id} value={user.user_id}>
                            {user.user_name} {user.user_lastname}
                          </option>
                        ))}
                      </TextField>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_img">
                    {({ field, form: { setFieldValue, touched, errors } }) => (
                      <>
                        <Button
                          variant="contained"
                          component="label"
                          color="primary"
                          sx={{ marginTop: '10px' }}
                        >
                          Cargar Imágenes
                          <input
                            type="file"
                            hidden
                            multiple
                            onChange={e => {
                              const files = Array.from(e.currentTarget.files);
                              setFieldValue('post_img', files);
                              setFieldValue('imageCount', files.length);
                            }}
                            accept="image/*"
                          />
                        </Button>

                        {field.value && field.value.length > 0 && (
                          <p>{field.value.length} imagen(es) seleccionada(s)</p>
                        )}
                        {errors.post_img && touched.post_img && (
                          <div style={{ color: 'red' }}>{errors.post_img}</div>
                        )}
                      </>
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Field name="post_url">
                    {({ field }) => (
                      <TextField
                        label="Post URL Video"
                        fullWidth
                        {...field}
                        error={Boolean(touched.post_url && errors.post_url)}
                        helperText={touched.post_url && errors.post_url}
                      />
                    )}
                  </Field>
                </Grid>

                <Grid item xs={12}>
                  <Label text="Fecha del post" />
                  <Field
                    as={TextField}
                    type="date"
                    name="post_date"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={touched.post_date && Boolean(errors.post_date)}
                    helperText={<ErrorMessage name="post_date" />}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Field name="type_id">
                    {({ field }) => (
                      <TextField
                        select
                        label="Tipo Blog"
                        fullWidth
                        {...field}
                        SelectProps={{ native: true }}
                        error={Boolean(touched.type_id && errors.type_id)}
                        helperText={touched.type_id && errors.type_id}
                      >
                        <option value="1">Anfitrión</option>
                        <option value="2">Espacios</option>
                        <option value="3">Invitados</option>
                      </TextField>
                    )}
                  </Field>
                </Grid>
              </Grid>

              {successMessage && (
                <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
                  <Alert
                    severity={
                      successMessage.includes('Error') ? 'error' : 'success'
                    }
                  >
                    {successMessage}
                  </Alert>
                </Box>
              )}
              <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{ paddingX: '20px', paddingY: '10px' }}
                >
                  Crear Blog
                </Button>
              </Box>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

export default BlogsForm;
